<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.title'
            "
            :data-default="{
                type: 'raw',
                value: 'Schreiben Sie einen Titel'
            }"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.text'
            "
            :data-default="{
                type: 'raw',
                value: 'Fassen Sie zusammen, worum es in dem Listenelemente geht.'
            }"
        ></app-wysiwyg>

        <app-filepicker
            label="Bild"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.image'
            "
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="false"
            :show-scaling-mode="true"
        ></app-filepicker>

        <app-link
            label="Button 1"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.link'
            "
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.link2'
            "
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.link3'
            "
        ></app-link>

        <app-filepicker
            label="Datei"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.items.' + listitemId + '.data.file'
            "
            accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.exe"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R094'),
            help: this.$helpers.uiText('R085'),
            removeText: this.$helpers.uiText('R095'),
            showGlobal: false
        });
        EventBus.$emit('slider-goto', {
            id: this.listitemId
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-filepicker': Filepicker,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link
    }
};
</script>
